import { caseDetailsPlugin } from 'utils'

export default (editor) => {
  editor.editorManager.PluginManager.add('casedetails', function (editor) {
    caseDetailsPlugin(editor)
  })
}
